import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FileUploaderComponent } from '@app/components';
import { AuthService, NotifyService } from '@app/services';
import { ApiValidationService } from '@app/services/api-validation.service';
import { BaseForm } from '@forms/base.form';
import { TrainingProgramRecord } from '@models/training/training-program-record.model';
import { RelationsUpdate } from '@training/services/form-file-manager.service';

@Component({
    selector: 'app-form-training-record',
    templateUrl: './record.template.html',
    styleUrls: ['./record.style.scss'],
})
export class RecordForm extends BaseForm implements OnInit {
    @ViewChild('fileUploader') fileUploader!: FileUploaderComponent;
    @Input() record = new TrainingProgramRecord();
    @Output() saveRecordEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() loading: EventEmitter<any> = new EventEmitter<any>();

    protected isEdit = false;

    constructor(
        public auth: AuthService,
        private notify: NotifyService,
        private validation: ApiValidationService
    ) {
        super();
    }

    ngOnInit(): void {
        this.record = new TrainingProgramRecord(this.record?.getAttributes() || []);
        this.isEdit = this.record.isComplete;
    }

    saveRecord(): void {
        this.submit();
        if (this.form.invalid) {
            return;
        }
        this.loading.emit(true);

        /**
         * Must get all file objects
         */
        this.fileUploader
            .saveFiles()
            .then((fileRelations: RelationsUpdate) => {
                this.record.attach('files', fileRelations.attach);
                this.record.detach('files', fileRelations.detach);

                this.record
                    .save()
                    .then(() => {
                        this.saveRecordEvent.emit(this.record);
                        this.loading.emit(false);
                        if (this.isEdit) {
                            this.notify.success('forms.training.editsSuccessfullySaved');
                            return;
                        }
                        this.notify.success('forms.training.trainingProgramRecorded');
                    })
                    .catch((err) => {
                        this.loading.emit(false);
                        try {
                            this.validation.errors(this.form, err);
                        } catch {
                            this.notify.error(err.message || 'forms.training.couldNotSaveTrainingDetails');
                        }
                    });
            })
            .catch((err) => {
                this.loading.emit(false);
                const errorMessage =
                    typeof err === 'string' ? err : err.message || 'forms.training.couldNotSaveAttachments';
                this.notify.error(errorMessage);
            });
    }
}
